import React, { Component, useState } from "react";
import { render } from "react-dom";
import AdminTerminos from "./JuryTerminosMobile";
import AdminTerminosD from "./JuryTerminosDesktop";
import { useMediaQuery } from 'react-responsive'


export default function AdminHomeResponsive(){
    const isMobileDevice = useMediaQuery({
        query: "(max-width: 48em)",
      });

  return(
      <div>
        {!isMobileDevice && <AdminTerminosD/>}
        {isMobileDevice && <AdminTerminos/>}  
      </div>
    )
}

